import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import AboutUs from "./AboutUs";
import Contact2 from "./Contact2";
import Contact from "./Contact";
import Pricing from "./PricingPage";
import Profiles from "./Profiles";
import SeeAllTestimonial from "./SeeAllTestimonial";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";

const HomeRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Home />} />
      <Route path="about-us" element={<AboutUs />} />
      <Route path="contact2" element={<Contact2 />} />
      <Route path="contact" element={<Contact />} />
      <Route path="pricing" element={<Pricing />} />
      <Route path="profiles" element={<Profiles />} />
      <Route path="testimonials" element={<SeeAllTestimonial />} />
      <Route path="terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default HomeRoutes;
